export default function LoadingScreen({ message = 'Loading…' }) {
  return (
    <div className="min-h-dvh flex flex-col items-center justify-center gap-4">
      <div className="relative">
        <div className="w-12 h-12 rounded-full border-2 border-obsidian-600 border-t-gold-500 animate-spin" />
        <div className="absolute inset-0 flex items-center justify-center text-xl">♟</div>
      </div>
      <p className="text-ivory-300/40 text-sm font-body animate-pulse">{message}</p>
    </div>
  )
}
